/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemReportsPageModule
 */

/**
 * Enum for representing the progress classes (success, error, warning).
 */
export enum PROGRESS_CLASSES {
    success = 'success',
    error = 'error',
    warning = 'warning',
}
